import * as React from 'react';
import { Grid } from 'react-bootstrap';

export default class Footer extends React.Component<{}, {}> {
  render() {
    return (
      <div className="footer">
        <Grid>
          <a href="http://diq-zert.de/de/impressum/">Impressum</a>&nbsp;|&nbsp;
          <a href="http://diq-zert.de/de/agb/">AGB</a>&nbsp;|&nbsp;
          <a href="http://diq-zert.de/de/datenschutz/">Datenschutzerklärung</a>
        </Grid>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/site/Footer.tsx